import * as d3 from "d3";
import { calcBoundedLimit } from "./utils";

/**
 * @this {import('alpinejs').AlpineComponent}
 */
export default function horizontalStackedChart(options) {
  let boundedHeight;
  let boundedWidth;
  let data;
  let stackedData;
  let x, color;
  let show = false;

  const scales = (xIndex, yIndex, data, colorRange) => {
    const newData = data.reduce(
      (acc, o) => ({ ...acc, [o[yIndex]]: +o[xIndex] }),
      {}
    );

    const stack = d3.stack().keys(Object.keys(newData));

    stackedData = stack([newData]);

    x = d3.scaleLinear().domain([0, 100]).range([0, boundedWidth]);
    color = d3.scaleQuantile().domain([0, 100]).range(colorRange);
  };

  const initializeSvg = (width, height, margin) => {
    const { boundedHeight: bh, boundedWidth: bw } = calcBoundedLimit(
      width,
      height,
      margin
    );
    boundedHeight = bh;
    boundedWidth = bw;
  };

  return {
    ...options,
    async init() {
      data = await d3.csv(options.url);

      this.$watch("width", () => {
        this.show = false;
        // on re-calcule tout
        initializeSvg(this.width, this.height, this.margin);
        scales(this.xIndex, this.yIndex, data, this.colorRange);
        this.$nextTick(() => (this.show = true));
      });
    },
    splitAt(s, at) {
      return [
        s.split(" ").slice(0, at).join(" "),
        s.split(" ").slice(at).join(" "),
      ].filter(Boolean);
    },
    get data() {
      return stackedData;
    },
    get boundedWidth() {
      return boundedWidth;
    },
    get x() {
      return x;
    },
    get color() {
      return color;
    },
    get show() {
      return show;
    },
    set show(s) {
      show = s;
    },
  };
}
